.header {
    border-bottom: 1px solid var(--mantine-color-ldGray-2);
    flex-shrink: 0;
}

.body {
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.actions {
    border-top: 1px solid var(--mantine-color-ldGray-2);
    flex-shrink: 0;
}

/* Fullscreen mode */
.fullScreenContent {
    height: calc(100dvh - (1rem * 2));
    width: calc(100dvw - (1rem * 2));
    display: flex;
    flex-direction: column;
}

.fullScreenBody {
    flex: 1;
    min-height: 0;
    overflow: auto;
}
